import Joi from 'joi';



function case1Validation(body) {
    if(!body.document_category) return { error: { details: [{ message: '"document category" is not allowed to be empty' }]}}
    else if(!body.document_type) return { error: { details: [{ message: '"document type" is not allowed to be empty' }]}}
    else if(!body.document_tag) return { error: { details: [{ message: '"document tag" is not allowed to be empty' }]}}

    return true;
}

function case2Validation(body) {
    const schema = Joi.object().keys({
        subject: Joi.string().required()
    });
    return schema.validate(body);
}

function case3Validation(body) {
    const schema = Joi.object().keys({
        sender: Joi.string().required(),
        recipients: Joi.array().min(1).required(),
        source: Joi.string().allow(''),
        address: Joi.string().allow('')
    });
    return schema.validate(body);
}

export function validateDocument(step, body) {
    let returnObj = { error: false };
    switch(step) {
        case 1: {
            const { error } = case1Validation(body);
            if(error) returnObj = { error: true, errorMessage: error.details[0].message }
            break;
        }
        case 2: {
            const { error } = case2Validation(body);
            if(error) returnObj = { error: true, errorMessage: error.details[0].message }
            break;
        }
        case 3: {
            const { error } = case3Validation(body);
            if(error) returnObj = { error: true, errorMessage: error.details[0].message }
            break;
        }
    }
    return returnObj;

}